<template>
    <div id="Confirmation" class="confirmationDiv" style="min-height: inherit; display: flex; flex-direction: column;">
        <Header title="Confirmation"/>
        <ErrorList v-if="error" :error="error"/>
        <div v-else class="mainbody">
            <div v-if="anySubmitted()" id="content">
                <h2 class="selfReportingConfirmation">Self-Reporting Confirmation</h2>
                <div class="bracket-green">
                    <p v-if="multipleSubmissions()">You have successfully submitted payroll for the following policies:</p>
                    <p v-else>You have successfully submitted payroll for the following policy:</p>
                </div>
                <p class="inset" v-for="(submission, i) in sortedPayroll" :key="i">
                    <strong>Policy:</strong> {{ submission.policyNumber }}<br>
                    <strong>Payroll Period:</strong> {{ reportingPeriod() }}<br>
                    <strong>Amount:</strong> {{ submission.premiumTotal | currency }}
                </p>
                <ul id="ConfirmationDetails">
                    <li>The premium amount above will be automatically withdrawn on <strong>{{ paymentDate() }}</strong>.</li>
                    <li>Returns are subject to a $25 service fee.</li>
                    <li>If you need to make changes, please contact your Account Manager at <a href="tel:+18447618400">844-761-8400</a>.</li>
                </ul>
                <h3 id="ConfirmationGratitude">Thank you for your business.</h3>

                <ReportingTable/>
            </div>
            <CompanyInfo/>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex';
import Header from './shared/Header';
import CompanyInfo from './shared/CompanyInfo';
import ErrorList from './shared/ErrorList';
import ReportingTable from "./ReportingTable";
import moment from 'moment';
import { create, reportingPeriod } from '@/utils/helpers';
import _ from 'lodash';

import mixin from './mixins/confAndReportingMixin';

export default {
    mixins:[mixin],
    name: 'Confirmation',
    components: { CompanyInfo, Header, ErrorList, ReportingTable },
    data() {
        return {
            error: null
        }
    },
    computed: {
        ...mapState([ 'contact', 'policies', 'submittedPayroll', 'reporting' ]),
        sortedPayroll: function() {
            return _.orderBy(this.submittedPayroll, 'invoiceId')
        }
    },
    created() {
        create(this)
    },
    methods: {  
        reportingPeriod() {
            return reportingPeriod(this.reporting.date)
        },
        paymentDate() {
            let today = moment(this.reporting.date)
            if (today.date() >= 20) {
                return today.add(1, 'month').set('date', 15).format('MM/DD/YYYY')
            } else {
                return today.set('date', 15).format('MM/DD/YYYY')
            }
        },
        multipleSubmissions() {
            return this.submittedPayroll.length > 1
        },
        hasPolicies() {
            return this.policies.length > 0
        },
        anySubmitted() {
            return this.submittedPayroll.length > 0
        }
    }
}
</script>

<style scoped>
</style>
